/*
  kvd-cmp-icons.js
  Setzt im Produktvergleich (custom_liquid "kvd-cmp" in den Produkt-Templates) vor jede Zeilen- und
  Gruppenbezeichnung ein Linien-Icon - dieselben Motive wie bei den Spezifikationen (snippets/kvd-spec-icons.liquid).
  Der Vergleich rendert per JS neu (Produktwechsel), deshalb per MutationObserver.
*/
(function () {
  if (window.__kvdCmpIcons) return;
  window.__kvdCmpIcons = true;

  var P = {
    rahmen: '<circle cx="3.5" cy="17" r="1"/><circle cx="20.5" cy="17" r="1"/><path d="M3.5 17 9.4 8.2M3.5 17H11M8.6 5.4 11 17M11 17l7.6-8.6M9.4 8.2h9M18.1 6.2l1.1 4.6L20.5 17M7 5.4h4"/>',
    gabel: '<path d="M12 2v4M7 6h10M8.5 6 7.5 19M15.5 6l1 13"/><circle cx="7.5" cy="20" r="1"/><circle cx="16.5" cy="20" r="1"/>',
    sattel: '<path d="M2.5 8.5c3.2-1.6 7.5-2.1 11.5-1.6 3.1.4 5.6 1.5 7.5 3.1-2.1 1-5.2 1.2-8.2.8-2.6-.3-4.6.3-6.6 1.1-2.1.8-3.9.2-4.2-3.4z"/><path d="M11.5 11.6 10 21M8 21h4"/>',
    cockpit: '<path d="M4.5 8h15M4.5 8C3 8 2.5 9.4 2.5 11.2s.8 3.4 2.6 3.8M19.5 8c1.5 0 2 1.4 2 3.2s-.8 3.4-2.6 3.8M10.5 8V6h3v2M12 8v9.5M10 19.5h4"/>',
    antrieb: '<circle cx="9" cy="12" r="6" stroke-dasharray="1.4 1.1"/><circle cx="9" cy="12" r="4.6"/><circle cx="9" cy="12" r="1.5"/><circle cx="19.5" cy="12" r="2"/><path d="M9 6 19.5 10M9 18l10.5-4"/>',
    motor: '<rect x="2.5" y="7" width="16" height="10" rx="2"/><path d="M18.5 10.5h1.5a1.5 1.5 0 0 1 1.5 1.5v0a1.5 1.5 0 0 1-1.5 1.5h-1.5"/><path d="M11.5 8.8 8.3 12.3h3.4l-2.2 3.4"/>',
    bremsen: '<circle cx="11" cy="13" r="7.5"/><circle cx="11" cy="13" r="2"/><path d="M11 6.5v2M17.5 13h-2M11 19.5v-2M4.5 13h2"/><path d="M14.8 3.7a10 10 0 0 1 5.5 5.5l-2.6 1.1a7.2 7.2 0 0 0-4-4z"/>',
    laufraeder: '<circle cx="12" cy="12" r="9.5"/><circle cx="12" cy="12" r="7.5"/><circle cx="12" cy="12" r="1.5"/><path d="M12 4.5v6M12 13.5v6M4.5 12h6M13.5 12h6M6.7 6.7l4.2 4.2M13.1 13.1l4.2 4.2M17.3 6.7l-4.2 4.2M10.9 13.1l-4.2 4.2"/>',
    gewicht: '<path d="M6 8h12l2.5 13h-17z"/><circle cx="12" cy="5" r="2"/>',
    geometrie: '<path d="M3 21h18M3 21V3M3 21 16 8"/><path d="M8.5 21a5.5 5.5 0 0 0-1.6-3.9"/>',
    preis: '<path d="M3 12.5V4h8.5l9.5 9.5-8.5 8.5z"/><circle cx="7.5" cy="8.5" r="1.4"/>',
    level: '<path d="M3.5 18a8.5 8.5 0 1 1 17 0"/><path d="M12 18l4.2-6"/><circle cx="12" cy="18" r="1"/>'
  };

  var MAP = {
    'spec level': 'level',
    'preis': 'preis',
    'rahmen': 'rahmen', 'rahmenset': 'rahmen',
    'gabel': 'gabel',
    'sattel': 'sattel', 'sattelstütze': 'sattel',
    'cockpit': 'cockpit', 'lenker': 'cockpit', 'vorbau': 'cockpit',
    'antrieb': 'antrieb', 'schaltung': 'antrieb', 'kassette': 'antrieb', 'kurbel': 'antrieb',
    'motor': 'motor', 'akku': 'motor', 'motor & akku': 'motor',
    'bremsen': 'bremsen', 'räder & bremsen': 'bremsen',
    'reifen': 'laufraeder', 'laufräder': 'laufraeder',
    'gewicht': 'gewicht',
    'geometrie': 'geometrie', 'reach': 'geometrie', 'stack': 'geometrie', 'radstand': 'geometrie',
    'lenkwinkel': 'geometrie', 'sitzrohrwinkel': 'geometrie', 'kettenstrebe': 'geometrie'
  };

  function decorate(root) {
    root.querySelectorAll('.kvd-cmp__spec-lbl-row > span, .kvd-cmp__group-hd-label').forEach(function (el) {
      if (el.querySelector('.kvd-cmp-icon')) return;
      var key = MAP[el.textContent.trim().toLowerCase()];
      if (!key) return;
      el.classList.add('kvd-cmp-has-icon');
      el.insertAdjacentHTML('afterbegin',
        '<svg class="kvd-cmp-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + P[key] + '</svg>');
    });
  }

  var style = document.createElement('style');
  style.textContent =
    '.kvd-cmp-has-icon{display:inline-flex;align-items:center;gap:7px}' +
    '.kvd-cmp__spec-lbl-row .kvd-cmp-icon{width:14px;height:14px;flex:none;color:#222}' +
    '.kvd-cmp__group-hd-label .kvd-cmp-icon{width:14px;height:14px;flex:none}';
  document.head.appendChild(style);

  var scheduled = false;
  function run() {
    scheduled = false;
    decorate(document);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(run);
  }
  function start() {
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
